import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../../../../components/flash-alert'
import Panel from '../../inputs/panel'
import ScheduleSettings from './schedule-settings'
import Preview from './preview'

import { ajaxGet, postForm, patchForm } from '../../../../ajax'

const Schedule = props => {
  const { register, reset, control, handleSubmit, setValue, getValues, setError, clearErrors, formState: { errors } } = useForm({})

  const {league} = props
  const [currentStep, setCurrentStep] = useState('Schedule Settings')
  const [loading, setLoading] = useState(true)
  const [schedule, setSchedule] = useState({})
  const [alert, setAlert] = useState(null)
  const [wdays, setWdays] = useState([])

  const [games, setGames] = useState([])
  const [fields, setFields] = useState([])
  const [teams, setTeams] = useState([])
  const [rounds, setRounds] = useState([])

  const requiredMsg = 'Is required'

  useEffect(() => {
    if (!props.schedule) loadDefaults()
    else initState()
  }, [])

  const initState = () => {
    reset(props.schedule)

    setSchedule(props.schedule)
    setWdays(props.schedule.wdays)

    setLoading(false)
  }

  const loadDefaults = async () => {
    const response = await ajaxGet(`/admins/leagues/${league.id}/schedule/new.json`)
    if (!response.ok) return

    const json = await response.json()
    reset(json.schedule)

    setSchedule(json.schedule)
    setWdays(json.schedule.wdays)

    setLoading(false)
  }

  const formattedDate = date => {
    const a = date.split('/')

    return a.slice(-1).concat(a.slice(0, 2)).join('-')
  }

  const prepareFormData = data => {
    const params = {
      'schedule[start_date]': formattedDate(data.start_date),
      'schedule[start_time]': data.start_time,
      'schedule[end_time]': data.end_time,
      'schedule[duration]': data.duration
    }

    var formData = new FormData()
    for (const [key, value] of Object.entries(params)) formData.append(key, value)
    wdays.forEach(day => formData.append('schedule[wdays][]', parseInt(day)))

    return formData
  }

  const prepareGameData = () => {
    var formData = new FormData()
    games.filter(g => g.checked).forEach((g, i) => {
      formData.append(`games[${i}][date]`, g.date)
      formData.append(`games[${i}][time]`, g.time)
      formData.append(`games[${i}][team1_id]`, g.team1_id)
      formData.append(`games[${i}][team2_id]`, g.team2_id)
      formData.append(`games[${i}][field_id]`, g.field_id)
      formData.append(`games[${i}][round]`, g.round)
    })

    return formData
  }

  const submitSchedule = async data => {
    const formData = prepareFormData(data)

    return !schedule.id ?
      postForm(`/admins/leagues/${league.id}/schedule.json`, formData) :
      patchForm(`/admins/leagues/${league.id}/schedule.json`, formData)
  }

  const validationError = () => {
    return {alert: {text: 'No games checked', type: 'alert'}}
  }

  const submitGames = async () => {
    const formData = prepareGameData()

    return formData.values().next().value ?
      postForm(`/admins/leagues/${league.id}/schedule/games.json`, formData) :
      { json: validationError }
  }

  const onSubmit = async data => {
    if (!validateDays()) return

    setLoading(true)

    if (currentStep == 'Schedule Settings') {
      const response = await submitSchedule(data)
      const json     = await response.json()

      setLoading(false)

      if (json.alert) setAlert(json.alert)
      else {
        props.onCreateSchedule(json.schedule)
        setCurrentStep('Preview')
      }
    } else {
      const response = await submitGames()
      const json     = await response.json()

      setLoading(false)

      if (json.alert) setAlert(json.alert)
      else {
        props.onCreateGames(json.games)
        props.onHide()
      }
    }
  }

  const validateDays = () => {
    if (wdays.length) return true

    var error = { type: 'manual', message: requiredMsg }
    setError('days', error)
    return false
  }

  const changeWDays = (value) => {
    clearErrors('days')
    setWdays(value)
  }

  return <Modal show={true} container={document.body} backdrop='static' dialogClassName='schedule-modal' onHide={props.onHide}>
    <Modal.Header closeButton>
      <Modal.Title>
        {schedule.id ? 'Update Schedule' : 'Create Schedule'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className={'schedule-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
        <Panel
          formName='schedule-form'
          steps={['Schedule Settings', 'Preview']}
          currentStep={currentStep}
        />
        {alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        {currentStep == 'Schedule Settings' &&
          <ScheduleSettings
            register={register}
            control={control}
            schedule={props.schedule}
            wdays={wdays}
            setWdays={changeWDays}
            hidden={false}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
          />
        }
        {currentStep == 'Preview' &&
          <Preview
            league={league}
            duration={schedule.duration}
            games={games}
            setGames={setGames}
            fields={fields}
            setFields={setFields}
            teams={teams}
            setTeams={setTeams}
            rounds={rounds}
            setRounds={setRounds}
            setAlert={setAlert}
            onPrevStep={() => setCurrentStep('Schedule Settings')}
            onLoading={value => setLoading(value)}
          />}
      </form>
    </Modal.Body>
  </Modal>
}

export default Schedule
